export default __webpack_public_path__ + "static/play-red-fb5380218a1f3fd3ef0bba310a6b7dc0.png";